export enum StatusID {
  ACTIVE = 1,
  INACTIVE = 2,
  SUSPENDED = 3,
  PENDING = 4,
  CONFIRMED = 5,
  CANCELLED = 6
}
